module.exports = __webpack_public_path__ + "img/s9.85f1b567.png";